import { useEffect, useMemo, useState } from 'react';
import { ENDPOINTS } from '../../../Utils/Endpoints';
import { Models } from '../../../Utils/ModelsGeneral';
import ConfirmDeleteDialog from '../../../../security/ConfirmDeleteDialog';
import axios from 'axios';
import Modal from './AvisosPrivacidadModal';
import sigmaDelete from '../../../../Pages/img/Borrar.png';
import sigmaEdit from '../../../../Pages/img/Editar.png';

const PAGE_SIZE = 10;

export default function AvisosPrivacidadCatalog() {
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [empresas, setEmpresas] = useState([]);
    const [query, setQuery] = useState('');
    const [modalOpen, setModalOpen] = useState(false);
    const [modalMode, setModalMode] = useState('new');
    const [selectedData, setSelectedData] = useState(null);
    const [deleteOpen, setDeleteOpen] = useState(false);
    const [deleteTarget, setDeleteTarget] = useState({ id: 0, name: '' });
    const [page, setPage] = useState(1);

    const loadData = async () => {
        setLoading(true);
        try {
            const [resAvisos, resEmpresas] = await Promise.all([
                axios.get(ENDPOINTS.avisosPrivacidad),
                axios.get(ENDPOINTS.empresas)
            ]);
            setRows((resAvisos.data || []).map(Models.avisosPrivacidad));
            setEmpresas((resEmpresas.data || []).map(Models.empresas));
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { loadData(); }, []);

    const filtered = useMemo(() => {
        const q = query.trim().toLowerCase();
        if (!q) return rows;
        return rows.filter((r) =>
            (r.avisoContenido || '').toLowerCase().includes(q)
        );
    }, [rows, query]);

    const totalPages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
    const paged = useMemo(() => {
        const start = (page - 1) * PAGE_SIZE;
        return filtered.slice(start, start + PAGE_SIZE);
    }, [filtered, page]);

    const handleNew = () => {
        setSelectedData(null);
        setModalMode('new');
        setModalOpen(true);
    };

    const handleEdit = (id) => {
        const r = rows.find(x => x.idAviso === id);
        setSelectedData(r);
        setModalMode('edit');
        setModalOpen(true);
    };

    const askDelete = (id) => {
        setDeleteTarget({ id, name: 'este aviso de privacidad' });
        setDeleteOpen(true);
    };

    const doDelete = async () => {
        try {
            await axios.delete(ENDPOINTS.avisosPrivacidadById(deleteTarget.id));
            setDeleteOpen(false);
            loadData();
        } catch (e) {
            console.error(e);
        }
    };

    const handleSubmit = async (payload, mode) => {
        try {
            if (mode === 'new') {
                await axios.post(ENDPOINTS.avisosPrivacidad, payload);
            } else {
                await axios.put(ENDPOINTS.avisosPrivacidad, payload);
            }
            setModalOpen(false);
            loadData();
        } catch (e) {
            console.error(e);
        }
    };

    const getEmpresaName = (id) => {
        return empresas.find(e => e.idEmpresa === id)?.nombre || 'N/A';
    };

    return (
        <div className="panel-sigma-main">
            <div className="roles-shell">
                <div className="roles-topbar">
                    <h2 className="roles-title">Avisos de Privacidad</h2>
                    <input
                        className="roles-search"
                        placeholder="Buscar por contenido..."
                        value={query}
                        onChange={(e) => { setQuery(e.target.value); setPage(1); }}
                    />
                    <button className="btn-action" onClick={handleNew}>＋ Nuevo</button>
                </div>

                <div className="roles-table-wrap">
                    <table className="roles-table">
                        <thead>
                            <tr>
                                <th>Contenido (Resumen)</th>
                                <th>Empresa</th>
                                <th>Caducidad</th>
                                <th style={{ textAlign: 'center' }}>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {paged.map((r) => (
                                <tr key={r.idAviso}>
                                    <td>{r.avisoContenido?.substring(0, 100)}...</td>
                                    <td>{getEmpresaName(r.idEmpresa)}</td>
                                    <td>{r.fechaCaducidad ? new Date(r.fechaCaducidad).toLocaleDateString() : '-'}</td>
                                    <td style={{ textAlign: 'center' }}>
                                        <div style={{ display: 'flex', justifyContent: 'center', gap: '8px' }}>
                                            <button className="rk-iconbtn rk-iconbtn--edit" onClick={() => handleEdit(r.idAviso)}>
                                                <img src={sigmaEdit} alt="Edit" className="rk-ico" />
                                            </button>
                                            <button className="rk-iconbtn rk-iconbtn--del" onClick={() => askDelete(r.idAviso)}>
                                                <img src={sigmaDelete} alt="Delete" className="rk-ico" />
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className="roles-pagination">
                    <div className="roles-pagination-left">
                        {filtered.length > 0 ? (
                            <span>Mostrando {(page - 1) * PAGE_SIZE + 1}–{Math.min(page * PAGE_SIZE, filtered.length)} de {filtered.length}</span>
                        ) : (
                            <span>0 resultados</span>
                        )}
                    </div>
                    <div className="roles-pagination-right">
                        <button className="roles-page-btn" onClick={() => setPage(p => Math.max(1, p - 1))} disabled={page === 1}>‹</button>
                        <button className="roles-page-btn is-active">{page}</button>
                        <button className="roles-page-btn" onClick={() => setPage(p => Math.min(totalPages, p + 1))} disabled={page === totalPages}>›</button>
                    </div>
                </div>

                {modalOpen && (
                    <div className="roles-editor-slot">
                        <Modal
                            open={modalOpen}
                            mode={modalMode}
                            data={selectedData}
                            empresaOptions={empresas}
                            inline
                            onClose={() => setModalOpen(false)}
                            onSubmit={handleSubmit}
                        />
                    </div>
                )}

                <ConfirmDeleteDialog
                    open={deleteOpen}
                    roleName={deleteTarget.name}
                    onClose={() => setDeleteOpen(false)}
                    onConfirm={doDelete}
                />
            </div>
        </div>
    );
}
